import { EntryTypeFieldType, FormulaType } from 'chaika-enums';

import { isDefined } from '@utils/isDefined';
import { DentalFieldData } from '@store/models/EntryFields';

import { DentalFormulaState } from '../types';

// До перехода на адресацию по имени поля формула писалась под строкой типа.
export const LEGACY_DENTAL_FIELD_NAME: string = EntryTypeFieldType.DentalTreatment;

interface Params {
    ownValue?: DentalFieldData;
    inheritedValue?: DentalFieldData;
    isInherent: boolean;
}

export function resolveDentalFieldValue({ ownValue, inheritedValue, isInherent }: Params): DentalFieldData | undefined {
    if (hasFormulaData(ownValue)) {
        return ownValue;
    }

    if (isInherent && hasFormulaData(inheritedValue)) {
        return inheritedValue;
    }

    return undefined;
}

export function hasToothData(formula?: DentalFormulaState): formula is DentalFormulaState {
    return isDefined(formula) && Object.keys(formula).length > 0;
}

export function pickFilledFormula(...values: (DentalFieldData | undefined)[]): DentalFieldData | undefined {
    return values.find(hasFormulaData);
}

function hasFormulaData(value?: DentalFieldData): value is DentalFieldData {
    if (!isDefined(value)) {
        return false;
    }

    return hasToothData(value[FormulaType.Permanent]) || hasToothData(value[FormulaType.Baby]);
}
